export const getObjectType = (pathname: string) => {
  const stepsFromEnd = pathname[pathname.length - 1] === '/' ? 3 : 2
  const splitPath = pathname.split('/')
  const objectTypePlural = splitPath[splitPath.length - stepsFromEnd]

  return objectTypePlural ? objectTypePlural.slice(0, objectTypePlural.length - 1) : ''
}
